module.exports = __webpack_public_path__ + "img/2.49f15d7f.png";